import Header from '../components/Header';
import Proxy from '../components/Proxy';
import Footer from '../components/Footer';
import usePageSeo from '../hooks/usePageSeo';
import { PAGE_SEO } from '../config/seo';

function ProxyPage() {
  usePageSeo(PAGE_SEO.proxy);

  return (
    <>
      <Header />
      <Proxy />
      <Footer />
    </>
  );
}

export default ProxyPage;
